
export const actionTypeSuccessShowAppReview = (actionType) => {
    //Actions types de 'SUCESSO' na execução dos serviços mapeadas para poder solicitar 
    //que o usuário avalie o APP.
    const typeSuccesso = [
        'EIR_EXTRATO_SUCESSO',
        'HISCRE_CREDITOS_RECEBIDOS',
        'ECNIS_EXTRATO_RECEBIDO',
        'ECO_EXTRATO_RECEBIDO'
    ]

    return typeSuccesso.includes(actionType);
}
